import { render, staticRenderFns } from "./OJT.vue?vue&type=template&id=53e33db7"
import script from "./OJT.vue?vue&type=script&lang=js"
export * from "./OJT.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports